import { appConfig } from "../../appConfig";
import { getQueryStringVariable } from "./getQueryStringVariable";

export function loadIdPvr() {
	let idPvr = null;
	const cg_USER = window.cg_USER;
	if (typeof cg_USER === 'object' && cg_USER != null) {
		if (cg_USER.pvr) {
			idPvr = cg_USER.idConto;
		}
	}
	if (idPvr == null) {
		idPvr = appConfig && appConfig.ID_PVR;
	}
	if ((idPvr || null) == null) {
		idPvr = getQueryStringVariable("idPvr");		
	}
	return idPvr === '' ? null: idPvr;
}
